import { render, staticRenderFns } from "./PermissionWorkflow.vue?vue&type=template&id=5a66e5f2&scoped=true"
import script from "./PermissionWorkflow.vue?vue&type=script&lang=js"
export * from "./PermissionWorkflow.vue?vue&type=script&lang=js"
import style0 from "./PermissionWorkflow.vue?vue&type=style&index=0&id=5a66e5f2&prod&lang=scss&scoped=true"
import style1 from "./PermissionWorkflow.vue?vue&type=style&index=1&id=5a66e5f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66e5f2",
  null
  
)

export default component.exports